import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Totalizer.styles.js';
import H from '../../components/Texts/H/H';
import P from '../../components/Texts/P/P';
import { numberFormatter } from '../../utils/Utils.js';

export const dateFormatter = (date) => {
  let dateSplitted = date.split(/[-,' ']/);
  return (
    dateSplitted[2] + ' ' + months[dateSplitted[1]] + ' ' + dateSplitted[0]
  );
};

const months = {
  '01': 'Ene',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Abr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Ago',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dic',
};

const Totalizer = ({ totalizerData }) => (
  <S.TotalizerWrapper data-testid={'totalizerContainer'}>
    {totalizerData.map((element, index) => (
      <S.TotalizerContent key={index} data-testid={'totalizer' + index}>
        <P type='2' variant={element.variant} modifier='regular' align='center'>
          {element.title}
        </P>
        <H type='5' align='center' weight='bold' variant={element.variant}>
          {formatters
            .find((e) => e.name === element.formatter)
            .value(element.value)}
        </H>
      </S.TotalizerContent>
    ))}
  </S.TotalizerWrapper>
);

const formatters = [
  { name: 'AmountFormatter', value: (e) => numberFormatter.format(e) },
  {
    name: 'NoFormatter',
    value: (e) => {
      return e;
    },
  },
  {
    name: 'DateFormatter',
    value: (e) => {
      return dateFormatter(e[0]) + ' - ' + dateFormatter(e[1]);
    },
  },
];

Totalizer.propTypes = {
  totalizerData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.array,
      ]).isRequired,
      variant: PropTypes.oneOf(['primary', 'neutral']).isRequired,
      formatter: PropTypes.oneOf([
        'AmountFormatter',
        'NoFormatter',
        'DateFormatter',
      ]),
    })
  ).isRequired,
};

Totalizer.defaultProps = {
  totalizerData: [
    {
      variant: 'neutral',
      formatter: 'NoFormatter',
    },
  ],
};

export default Totalizer;
